import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import NavbarLogo from "./navbar/NavbarLogo";
import NavbarDesktop from "./navbar/NavbarDesktop";
import NavbarMobile from "./navbar/NavbarMobile";

interface NavbarProps {
  isDarkTheme?: boolean;
}

const Navbar = ({ isDarkTheme = true }: NavbarProps) => {
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const location = useLocation();
  
  // Ensure home path matches correctly
  const isHomePage = location.pathname === "/" || location.pathname === "/home";

  // Add scroll event listener to detect when page is scrolled
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <>
      {/* Fixed navbar */}
      <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? isDarkTheme 
            ? 'bg-black/80 backdrop-blur-md shadow-md' 
            : 'bg-white/80 backdrop-blur-md shadow-md' 
          : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-4 flex items-center justify-between py-4">
          <NavbarLogo isDarkTheme={isDarkTheme} />
          
          {/* Desktop Navigation */}
          <NavbarDesktop 
            isDarkTheme={isDarkTheme} 
            isHomePage={isHomePage} 
          />
          
          {/* Mobile Navigation */}
          {isMobile && (
            <NavbarMobile 
              isDarkTheme={isDarkTheme} 
              isHomePage={isHomePage} 
            />
          )}
        </div>
      </div>
      
      {/* Spacer div that pushes content below the fixed navbar */}
      <div className="h-16"></div>
    </>
  );
};

export default Navbar;
